import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Grid
} from '@material-ui/core';
import { theme } from 'highcharts';

const styles = makeStyles(theme => ({
	gridContainer: {
		position: "relative",
		height: theme.spacing(7),
		flex: 1,
		gap: 10,

		// [theme.breakpoints.up('xl')]: {
		// 	gap: 0,
		// 	justifyContent: "space-between"
		// }
	},

	alert: {
		color: "#E81717"
	},

	chat: {
		color: "#99CBD2"
	},

	// icon: {
	// 	opacity: 0.2,
	// 	fontSize: "3rem",
	// 	position: "absolute",
	// 	right: theme.spacing(1)
	// },

	value: {
		fontSize: "20px",
		color: theme.palette.secondary.grey,
		fontWeight: 800,
		lineHeight: "30px",
	},

	label: {
		fontSize: "12px",
		color: theme.palette.secondary.grey,
		fontWeight: 600,
		lineHeight: "16px",
	}
}));

function PatternMetricsCard(props) {
	let classes = styles(),
		{data, icon, value, label, className, colorClass} = props;

	return (
		<Grid container
			wrap="nowrap"
			justifyContent="flex-start"
			alignItems='center'
			className={`${classes.gridContainer} ${className}`}>
			<Grid item className={`${colorClass}`}>
				<FontAwesomeIcon
					icon={icon}
					size="lg"
				 />
			</Grid>
			<Grid item>
				<Grid container
					direction="column"
					justifyContent="flex-start">
					<Grid item className={classes.value}>
						{value}
					</Grid>
					<Grid item className={classes.label}>
						{label}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

PatternMetricsCard.propTypes = {
	data: PropTypes.object,
	icon: PropTypes.array,
	value: PropTypes.number,
	label: PropTypes.string,
	className: PropTypes.string
};

export default PatternMetricsCard;